import React, { useState } from 'react';
import {
  Grid, Typography,
} from '@mui/material';
import { useFormikContext } from 'formik';
import _ from 'lodash';
import PropTypes from 'prop-types';
import useMediaQuery from '@mui/material/useMediaQuery';
import SliderMarkSVGR from '../../../../assets/svgr/SliderMarkSVGR';
import './styles.scss';
import CustomSlider from '../../../../styles/overrides/MaterialUIComponents/MaterialUISlider';
import { POTENTIAL_REDUCTION_ESTIMATED } from '../../../../constants';

const CustomThumb = (props) => (
  <span {...props}>
    <SliderMarkSVGR className='svg-slider-mark-svgr-unborder' />
  </span>
);

const ConfirmStep = () => {
  const largeScreen = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  const { setFieldValue, values } = useFormikContext();
  const [potentialReductionEstimated, setPotentialReductionEstimated] = React.useState(_.get(values, 'benefitEstimator.potentialReductionEstimated'));

  const [potentialReductionEstimatedSliderValue, setPotentialReductionEstimatedSliderValue] = useState(potentialReductionEstimated || POTENTIAL_REDUCTION_ESTIMATED.MAX);

  const handleChange = (event, newValue) => {
    if (typeof newValue === 'number') {
      setPotentialReductionEstimatedSliderValue(newValue);
      setFieldValue('benefitEstimator.potentialReductionEstimated', newValue);
      setPotentialReductionEstimated(newValue);
    }
  };

  return (
    <Grid container spacing={2} justifyContent={largeScreen ? 'flex-start' : 'center'} ml={!largeScreen ? -1.5 : ''} pr={!largeScreen ? 3 : ''}>
      <Typography ml={-0.25} className='steps-wizard-steps question-text'>Potential Social Security benefit reduction in 2033</Typography>
      <Typography className='steps-wizard-steps question-desc'>
        This tool defaults to a 21% reduction of benefits in 2033, which is
        the official forecast from the Social Security Administration. You can lower the projected reduction estimate, but you
        cannot increase it above the maximum.
        <sup>2</sup>
      </Typography>
      <Grid container direction='row' alignItems='center'>
        <Grid item xs={8} sm={9} md={8.2} lg={9}>
          <CustomSlider
            value={potentialReductionEstimatedSliderValue}
            ThumbComponent={CustomThumb}
            name='potentialReductionEstimated'
            min={1}
            step={1}
            max={POTENTIAL_REDUCTION_ESTIMATED.MAX}
            onChange={handleChange}
            aria-label='Default'
          />
        </Grid>
        <Typography className='steps-wizard-steps answer-slider-value'>
          {' '}
          {potentialReductionEstimatedSliderValue}
          %
        </Typography>
      </Grid>
    </Grid>
  );
};

CustomThumb.propTypes = {
  children: PropTypes.shape(),
};

CustomThumb.defaultProps = {
  children: undefined,
};

export default ConfirmStep;
